import { isEmpty } from 'lodash';

export function isSignedIn(state) {
  return !isEmpty(state.user);
}

export function currentUser(state) {
  return state.user;
}

export function currentUserId(state) {
  return state.user.id;
}

export function userGradeId(state, getters) {
  return getters.currentUser.grade;
}

export function getIsDevice(state) {
  return !isEmpty(state.device);
}

export function isParentUser(state, getters) {
  return getters.currentUserRole === 'parent';
}

export function isStudentUser(state, getters) {
  return getters.currentUserRole === 'student';
}

export function isTeacherUser(state, getters) {
  return getters.currentUserRole === 'teacher';
}

export function currentUserContryCode(state, getters) {
  return getters.currentUser.country_code || 'KR';
}

export function currentUserLanguage(state, getters) {
  return getters.currentUser.language || 'ko';
}

export function isAISupportCountry(state, getters) {
  return getters.currentUserContryCode === 'KR';
}

export function currentUserRole(state) {
  if (!state.user) {
    return null;
  }

  return state.user.role;
}

export function isPrime(state) {
  return state.user.is_prime;
}

export function userLicence(state) {
  return state.userLicence;
}

export function isUserLicence(state) {
  if (isEmpty(state.userLicence)) {
    return false;
  }

  return true;
}

export function isPremiumSchool(state) {
  return state.premiumSchool && state.premiumSchool.is_premium_school;
}

export function isSubscriptionUser(state, getters) {
  return getters.isPrime ||
    getters.isUserLicence ||
    getters.isPremiumSchool;
}

export function getAllowedQuizzesCount(state) {
  return state.userLicence && state.userLicence.allowed_quizzes_count;
}
